
export default class Template {
  constructor (name, path, img, active) {
    this.name = name;
    this.path = path;
    this.img = img;
    this.active = active;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/ui/Template.js